/** Pending deep-link bridge.
 *
 *  The router guard (src/router/index.ts) stashes the target path into
 *  sessionStorage when an unauthenticated visitor hits a gated route
 *  (typically `/checkin/:barId` from a bar QR). After the visitor
 *  finishes LINE login + consent + profile, the onboarding pages call
 *  `consumePendingDeepLink()` to retrieve and clear it — so the user
 *  lands back on the page they originally aimed at instead of `/me`.
 */
const KEY = "pendingDeepLink";

export function consumePendingDeepLink(): string | null {
  const target = sessionStorage.getItem(KEY);
  if (!target) return null;
  sessionStorage.removeItem(KEY);
  return target;
}
